import { render, staticRenderFns } from "./best-mobile-running.component.vue?vue&type=template&id=5a640f49&scoped=true"
import script from "./best-mobile-running.component.vue?vue&type=script&lang=js"
export * from "./best-mobile-running.component.vue?vue&type=script&lang=js"
import style0 from "./best-mobile-running.component.vue?vue&type=style&index=0&id=5a640f49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a640f49",
  null
  
)

export default component.exports